/* eslint-disable react/function-component-definition */
import React from 'react';

/*
 * User-defined form title, subtitle and hardcoded fail text
 * "form": {
 *    "title": "",
 *    "subtitle": [""],
 *   }
 *
 */
// import styled from 'styled-components';

export const FormTitle = (data) => {
  const { title, mode } = data;
  return title && title !== undefined ? (
    <h3 className={`${mode === 'dark' && 'text-white'} text-left`}>{title}</h3>
  ) : null;
};

export const FormSubtitle = (data) => {
  const { subtitle, mode } = data;

  // const SubtitleClass = styled.div`
  //   ul {
  //     list-style: none;
  //     padding-left: 0;

  //     li {
  //       position: relative;
  //       padding-left: 2rem;
  //       margin-bottom: 0.5rem;

  //       &:before {
  //         content: '';
  //         position: absolute;
  //         left: 0;
  //         top: 0.25rem;
  //         width: 1.3rem;
  //         height: 1.3rem;
  //         background-image: url(https://voyager.postman.com/icon/checkbox-outline-green-icon.svg);
  //         background-repeat: no-repeat;
  //         background-size: contain;
  //       }
  //     }
  //   }

  //   ol {
  //     li {
  //       list-style-type: decimal !important;
  //       &:before {
  //         content: '';
  //       }
  //     }
  //   }
  // `;
  return subtitle && subtitle.length > 0 ? (
    <div
      className={`${mode === 'dark' && 'text-white'}  text-left mb-3`}
      dangerouslySetInnerHTML={{
        __html: subtitle.join('')
      }}
    />
  ) : null;
};
export const FormFailText = (data) => {
  const { mode } = data;
  return (
    <p
      className="subtitle"
      style={{ color: mode === 'dark' ? '#FFFFFF' : '#6b6b6b' }}
    >
      Sorry! Something went wrong loading the form. Please refresh your browser,
      disable ad-blockers or try again later.
    </p>
  );
};
